import Vuex from 'vuex';
import moduleStore from './register-module';
import applyFindSearchBar from './applyFindSearchBar';
import common from './modules/common';
import user from './modules/user';
import building from './modules/building';
// import search from './modules/search';
import track from './modules/track';
import page from './modules/page';
import chat from './modules/chat';
//  Convenient for other non-  vue  Instances refer to global state 
export let store;

export default Vue => {
    if (!store) {
        Vue.use(Vuex);
        Vue.use(moduleStore);
        store = new Vuex.Store({
            modules: {
                common,
                user,
                track,
                building,
                // search,
                page,
                chat
            }
        });

        //  exist store There are some methods to find search bar related child module
        applyFindSearchBar(store);
    }
    if (
        typeof window.__INITIAL_STATE__ !== 'undefined' &&
        window.__INITIAL_STATE__.state
    ) {
        store.replaceState(window.__INITIAL_STATE__.state);
    }
    return store;
};
